// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"d7d6abd4","453":"c952c5fb"}[chunkId] + ".chunk.js";
};